export const getDefaultDepositGearIndex = (
  gears?: Array<unknown> | null,
): number => {
  if (!gears?.length) {
    return -1;
  }
  return 0;
};
